import React from 'react';
import { StyleSheet, View } from 'react-native';
import { useStyle } from 'react-native-style-utilities';

import { BodyText, Icon, QRCode, theme } from '@sg/garnish';

import { type ScanToPayPalette, titlePalettes } from '../../utils';

export const ScanToPayQrCode = (props: ScanToPayQrCodeProps) => {
  const { title, palette, qrCode, hexagonSize, qrCodeSize } = props;

  const hexagonStyle = useStyle(
    () => ({
      width: hexagonSize,
      height: hexagonSize,
    }),
    [hexagonSize],
  );

  const qrCodeStyle = useStyle(
    () => ({
      width: qrCodeSize,
      height: qrCodeSize,
    }),
    [qrCodeSize],
  );

  return (
    <View style={styles.container}>
      <BodyText sizeMatch={['22']} style={[styles.title, titlePalettes[palette]]}>
        {title}
      </BodyText>

      <View style={[styles.qrCodeContainer, hexagonStyle]}>
        <View style={[styles.hexagon, hexagonStyle]}>
          <Icon
            name="IconHexagonQRCode"
            width={hexagonSize}
            height={hexagonSize}
            color={hexagonColor[palette]}
          />
        </View>

        <View style={[styles.qrCode, qrCodeStyle]}>
          <QRCode
            ecl="L"
            size={qrCodeSize}
            color={qrCodeColor[palette]}
            backgroundColor={hexagonColor[palette]}
            value={qrCode}
          />
        </View>
      </View>
    </View>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const hexagonColor = {
  cream: theme.colors.KALE,
  'dark-kale': theme.colors.CREAM,
};

const qrCodeColor = {
  cream: theme.colors.WHITE,
  'dark-kale': theme.colors.BLACK,
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    paddingTop: theme.spacing['6'],
    gap: theme.spacing['10'],
  },
  title: {
    textAlign: 'center',
    paddingHorizontal: theme.spacing['4'],
    color: theme.colors.KALE,
  },
  qrCodeContainer: {
    padding: theme.spacing['4'],
    alignItems: 'center',
    justifyContent: 'center',
  },
  hexagon: {
    position: 'absolute',
  },
  qrCode: {
    position: 'absolute',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type ScanToPayQrCodeProps = {
  title: string;
  qrCode: string;
  hexagonSize: number;
  qrCodeSize: number;
  palette: ScanToPayPalette;
};
